export enum ScopePlanned {
  Advanced = 'Advanced',
  AdvancedHighResolution = 'Advanced (High Resolution)',
  PartiallyVolumetric = 'Partially Volumetric',
  Basic = 'Basic',
  BasicHighResolution = 'Basic (High Resolution)',
  BasicForTAOnly = 'Basic (for TA only)',
  LiDAR = 'LiDAR',
  PanoOnly = '360s only',
  DataProcessingOnly = 'Data processing only',
  Video = 'Video',
  AdditionalImages = 'Additional Images',
  Planimetrics = 'Planimetrics (orthophoto, dem, tin)',
}
